import "core-js/modules/es6.function.name";

/**
 * @module
 * @private
 *
 * @description Deprecation tools for selectors.
 */
import { printDeprecationWarning } from '@nerdwallet/deprecate';
/**
 * Type definitions.
 * @callback selector
 * @param {Object} marketplaceEntity
 * @returns {*}
 */

/**
 * Decorator for deprecating a selector.
 *
 * @param {Function} fn - The decorated function.
 * @param {Object} options
 * @param {String} options.migration - How to mediate deprecation.
 * @param {String} options.name - The name of the deprecated function.
 * @param {String} options.scope - The selector context.
 * @param {String} options.version - Since when it has been deprecated.
 * @returns {selector} - The selector with deprecation announcement.
 */

export var withDeprecationWarning = function withDeprecationWarning(fn) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      migration = _ref.migration,
      name = _ref.name,
      scope = _ref.scope,
      version = _ref.version;

  return function () {
    var functionName = fn.name;
    var message = "\"".concat(scope ? "".concat(scope, "/") : '').concat(name || functionName, "\" has been deprecated").concat(version ? " since v".concat(version) : '', ".").concat(migration ? " ".concat(migration) : '');
    printDeprecationWarning({
      message: message
    });
    return fn.apply(void 0, arguments);
  };
};
/**
 * Create withDeprecationWarning with module context.
 * @example
 * module = 'banking'
 * makeModuleWithDeprecationWarning('banking') // => `banking/foo has been deprecated...`
 *
 * @param {String} module - The context of the selector.
 * @returns {withDeprecationWarning}
 */

export var makeModuleDeprecationDecorator = function makeModuleDeprecationDecorator(module) {
  return function (fn, _ref2) {
    var version = _ref2.version,
        migration = _ref2.migration,
        name = _ref2.name;
    return withDeprecationWarning(fn, {
      version: version,
      migration: migration,
      name: name,
      scope: module
    });
  };
};